var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as baobab from '@data/baobab/baobab';
import React, { useEffect, useState } from 'react';
import FSButton from '../components/FSButton';
import { useMaintenanceInfo } from '../data/maintenance/maintenanceActions';
import eventEmiter from './Emitter';
import { useLanguage } from './LanguageProvider';
export function MaintenanceModeWrapper(props) {
    var _this = this;
    var _a, _b, _c, _d;
    var L = useLanguage().L;
    var tenantId = baobab.root.get(['currentUser', 'tenantId']);
    var maintenanceInfo = useMaintenanceInfo(tenantId);
    var _e = __read(useState(false), 2), isRefetching = _e[0], setIsRefetching = _e[1];
    var _f = __read(useState(false), 2), requestInMaintenance = _f[0], setRequestInMaintenance = _f[1];
    useEffect(function () {
        var maintenanceHandler = function (inMaintenance) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                setRequestInMaintenance(inMaintenance);
                return [2 /*return*/];
            });
        }); };
        eventEmiter.on('maintenance', maintenanceHandler);
        return function () {
            eventEmiter.off('maintenance', maintenanceHandler);
        };
    }, [tenantId, (_a = maintenanceInfo.data) === null || _a === void 0 ? void 0 : _a.maintenance]);
    if ((((_b = maintenanceInfo.data) === null || _b === void 0 ? void 0 : _b.maintenance) || requestInMaintenance) && !((_c = maintenanceInfo.data) === null || _c === void 0 ? void 0 : _c.superUser)) {
        return (React.createElement("div", { className: "global-error" },
            React.createElement("div", { className: "global-error-content" },
                React.createElement("h2", null, L('Maintenance mode is currenty enabled')),
                React.createElement("p", null, L('Please wait or contact your administrator for more information.')),
                React.createElement(FSButton, { title: L('Retry'), loading: isRefetching, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setIsRefetching(true);
                                    return [4 /*yield*/, maintenanceInfo.refetch({ throwOnError: false })];
                                case 1:
                                    _a.sent();
                                    setIsRefetching(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); }, style: { marginTop: '1em' } }))));
    }
    return React.createElement(React.Fragment, null, (_d = props === null || props === void 0 ? void 0 : props.children) !== null && _d !== void 0 ? _d : null);
}
